import styled from 'styled-components';
import Image1 from '../../assets/image/icon/button.png'
import '../styles/FadeInFromBottom.css'
import FadeInFromBottom from '../shared/FadeInFromBottom';

const Wrapper = styled.div`
  a {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
        font-size: 12px;
        font-weight: 600;
        margin-right: 12px;
        color: #030000;
    }
    img {
        height: 28px;
        width: auto;
    }
  }
`;

const Button = (props) => {
  return (
    <Wrapper>
      <FadeInFromBottom>
        <a target="_blank" href={props.url} rel="noopener noreferrer">
          <span>{props.buttonText}</span>
          <img src={Image1} alt="ボタン" />
        </a>
      </FadeInFromBottom>
    </Wrapper>
  );
};
  
export default Button;
  